import { Flex, IconButton, TextV2, styled } from '@withjoy/joykit';
import { Guests, Trash } from '@withjoy/joykit/icons';
import React from 'react';
import { GlobeIcon } from './Globe';

type EventRowProps = {
  title: string;
  subtitle?: string;
  onPrivacyClick?: () => void;
  isPublic?: boolean;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  showVisibilityToggle?: boolean;
  onVisibilityChange?: (newValue: boolean) => void;
  isVisible?: boolean;
};

const StyledEventRow = styled(Flex)`
  background: var(--System-White, #fff);
  border-radius: 4px;
  cursor: pointer;
  justify-content: space-between;
  padding: 16px;
  transition: background-color 0.3s ease;
  user-select: none;

  &:hover {
    background: var(--mono-2-bg, #f7f7f7);
  }

  &:active {
    background: var(--mono-3-lines, #ebebeb);
  }
`;

export const EventRow = (props: EventRowProps) => {
  const { title, isPublic, subtitle, onEditClick, onPrivacyClick, onDeleteClick } = props;
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <StyledEventRow
      onClick={() => {
        onEditClick && onEditClick();
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Flex
        flexDirection="column"
        gap="4px"
      >
        <TextV2 typographyVariant="body1">{subtitle ?? ''}</TextV2>
        <TextV2 typographyVariant="hed2">{title}</TextV2>
      </Flex>
      <Flex gap="8px">
        <Flex
          padding="10px"
          alignItems="center"
          justifyContent="center"
          onClick={onPrivacyClick}
        >
          {isPublic ? <GlobeIcon /> : <Guests height="fit-content" />}
        </Flex>
        <Flex
          padding="10px"
          alignItems="center"
          justifyContent="center"
        >
          <IconButton
            aria-label="Delete"
            variant="ghost"
            height="fit-content"
            onClick={e => {
              e.stopPropagation();
              onDeleteClick?.();
            }}
            opacity={isHovered ? 1 : 0}
            transition={'opacity 0.1s ease'}
          >
            <Trash color="buttonDestructiveFill" />
          </IconButton>
        </Flex>
      </Flex>
    </StyledEventRow>
  );
};
